export const ADDRESS_QUERY_KEYS = {
  default: () => ['address'] as const,
  normalize: () => [...ADDRESS_QUERY_KEYS.default(), 'normalize'] as const,
};
